// ===========================================
// The enquiry a Meet & Greet is linked to (enquiries plan §8.3)
// ===========================================
// "Enquiry: <name> · <stage>", opening that enquiry on the Enquiries page. The server sends
// `enquiry` only to a caller holding `enquiries.read` (null otherwise), so a null renders nothing
// and the config read below is only ever made by someone who may read enquiries. The stage name is
// the SCHOOL's own label, never the built-in one.

import { Chip } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTenant } from '../../../contexts/TenantContext';
import { useEnquiryConfig } from '../../../hooks/useEnquiries';
import type { LinkedEnquiry } from '../../../api/meetAndGreet.api';
import { STAGE_COLORS, stageLabel } from './enquiryUi';

function Linked({ enquiry }: { enquiry: LinkedEnquiry }) {
  const { schoolSlug } = useTenant();
  const { data: config } = useEnquiryConfig();
  const colors = STAGE_COLORS[enquiry.stage];
  const name = [enquiry.firstName, enquiry.lastName].filter(Boolean).join(' ');
  return (
    <Chip
      component={RouterLink}
      to={`/${schoolSlug}/admin/enquiries?enquiry=${encodeURIComponent(enquiry.id)}`}
      clickable
      size="small"
      data-testid="linked-enquiry-chip"
      label={`Enquiry: ${name} · ${stageLabel(config, enquiry.stage)}`}
      aria-label={`Open the enquiry from ${name}, ${stageLabel(config, enquiry.stage)}`}
      sx={colors ? { bgcolor: colors.bg, color: colors.text, fontWeight: 500, maxWidth: '100%' } : { maxWidth: '100%' }}
    />
  );
}

export default function LinkedEnquiryChip({ enquiry }: { enquiry: LinkedEnquiry | null | undefined }) {
  if (!enquiry) return null;
  return <Linked enquiry={enquiry} />;
}
